module.exports = __webpack_public_path__ + "static/media/osoglas03.274b2eb8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/OfficeShoes/osoglas03.jpg
// module id = 399
// module chunks = 0